// 商品销售统计

import mainServerClient from "@/services/http/mainServerClient";

export interface ProductSalesStatsTask {
    id: number;
    companyId: number;
    created: string;
    distributedTaskId: number;
    downloadUrl: string;
    shippingEnd: string;
    shippingStart: string;
    shopIds: number[];
    status: "COMPLETED" | "ERROR" | "PENDING" | "RUNNING";
    hasDownloadUrl: boolean;
    statsProductStatuses: StatsProductStatus[];
    statsProductInfos: StatsProductInfo[];
}

// 获取当前用户的下载任务列表
export function getExportTask({ pageNo, pageSize }): Promise<{ items: ProductSalesStatsTask[]; totalCount: number }> {
    return mainServerClient.get("/productSalesStats", { pageNo, pageSize });
}

/**
 * 指定需要统计的商品信息。
 *
 * StatsProductInfo
 */
export interface StatsProductInfo {
    /**
     * 图片。
     * <p>优先使用 SKU 图片，如果 SKU 没有图片则使用商品图片。
     */
    picture?: string;
    /**
     * 商品平台 ID
     */
    productOriginalId?: string;
    /**
     * 商品标题
     */
    productTitle?: string;
    /**
     * 店铺 ID
     */
    shopId?: number;
    /**
     * SKU 平台 ID
     */
    skuOriginalId?: string;
    /**
     * SKU 属性
     */
    skuProperties?: string;
}

export enum StatsProductStatus {
    CANCELED = "CANCELED",
    REFUNDING = "REFUNDING",
    SHIPPED = "SHIPPED",
    SUCCESS = "SUCCESS",
}

interface exportParams {
    /**发货结束时间，格式yyyy-MM-dd HH:mm:ss */
    shippingEnd: string;

    /**发货开始时间，格式yyyy-MM-dd HH:mm:ss */
    shippingStart: string;

    /** 空值代表导出所有店铺 */
    shopIds: number[];

    /** 指定需要统计的商品状态列表 */
    statsProductStatuses?: StatsProductStatus[];

    /**
     * 指定需要统计的商品信息列表。
     */
    statsProductInfos?: StatsProductInfo[];
}

// 导出
export function exportProductSalesStats(params: exportParams) {
    return mainServerClient.post("/productSalesStats", params);
}

export function getProductSalesStatsDownloadUrl(taskId: number) {
    return mainServerClient.get<string>("/productSalesStats/download_url", { taskId });
}

export default {
    getExportTask,
    exportProductSalesStats,
};
